import { render } from "./VerticalNavMenu.vue?vue&type=template&id=7b66e33f"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js"
script.render = render

export default script